import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { CarouselItem, useCarouselApi } from '@elfsight/lib-carousel';
import type { MediaImageProps } from '@elfsight/widget-media';
import type { MediaValue } from '../../../data/sources';
import { Media } from './Media';
import type { PickedMediaImageProps } from './media-video';

type OnLoadHandlerType = NonNullable<MediaImageProps['onLoad']>;

interface MediaCarouselItemProps extends PickedMediaImageProps {
  item: MediaValue;
}

export function MediaCarouselItem({
  item,
  onLoad: derivedOnLoadHandler,
  ...mediaImageProps
}: MediaCarouselItemProps) {
  const [aspectRatio, setAspectRatio] = useState(0);
  const carouselRef = useRef<HTMLDivElement | null>(null);
  const carouselApi = useCarouselApi();

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;

    let rafId: number;

    const observer = new ResizeObserver(() => {
      rafId = requestAnimationFrame(() => {
        carouselApi.updateAutoHeight();
      });
    });

    observer.observe(el);

    return () => {
      observer.disconnect();
      cancelAnimationFrame(rafId);
    };
  }, [carouselApi]);

  // @ts-expect-error Проблемы с конфликтом типа ReactEventHandler<HTMLDivElement>
  const onLoad: OnLoadHandlerType = (_event, size) => {
    derivedOnLoadHandler?.();

    if (size) {
      const { width, height } = size;
      if (height && width) {
        setAspectRatio(height / width);
      }
    }
  };

  return (
    <StyledCarouselItem ref={carouselRef}>
      <Media
        {...mediaImageProps}
        media={item}
        ratio={aspectRatio < 1 ? aspectRatio : 0}
        onLoad={onLoad}
      />
    </StyledCarouselItem>
  );
}

const StyledCarouselItem = styled(CarouselItem)``;
